import React, { useContext, useEffect, useState } from "react";
import { FaRegCalendarAlt, FaRegClock, FaSun, FaMoon } from "react-icons/fa";
import { astro_details, birth_details, numero_table } from "../../../ApiServices/Horoscope/BirthDetailsApi";
import { GetProfileDetails, GetUserModel } from "../../../ApiServices/Profile/ProfileApi";
import Breadcrumbs from "../../Breadcrumb";
import HoroscopeBannerImg from "../../../assets/images/new/HoroscopeBanner.png";
import astroBackgroundImg from "../../../assets/images/Horoscope/horoscopeBackgroundImg.png";
import dayjs from "dayjs";
import { LoaderContext } from "../../../AuthContext/AuthContext";
import astrology from "../../../assets/images/new/astrology.png";
import panchang from "../../../assets/images/new/panchang.png";
import numerology from "../../../assets/images/new/numerology.png";
import zodiacSign from "../../../assets/images/new/zodiacSign.png";
import Astro from "../../../assets/images/new/services1 (1).jpg";
import Panchang from "../../../assets/images/new/services1 (2).jpg";
import NumerologyImage from "../../../assets/images/new/services1 (3).jpg";
import AstrologyIo from "../../../assets/images/new/astrologer.png";
import AstrologyIt from "../../../assets/images/new/earth.png";
import AstrologyItone from "../../../assets/images/new/earthone.png";
import AstrologyIf from "../../../assets/images/new/solar.png";
import Prediction from "../../../assets/images/new/services1 (3).jpg";
import Pridictions from "../../../assets/images/new/astrologerone.png";
import { useLocation, useNavigate } from "react-router-dom";
import { t } from "i18next";
import ErrorMassagePupUp from "../../ErrorMassagePupUp";

const BasicDetails = () => {
  const [animate, setAnimate] = useState(false);
  const [basicDetails, setBasicDetailsObj] = useState([]);
  const [astroDetails, setAstroDetailsObj] = useState([]);
  const { setLoader, pujaStatus, fetchedLocation, timezoneOffset, convertTo12Hour } = useContext(LoaderContext);
  const navigate = useNavigate()
  const location = useLocation()
const [showErrorModal,setShowErrorModal]=useState(false)
const [customErrorMassage,setCustomErrorMassage]=useState("")



  useEffect(() => {
    GetUserModelData();
    setTimeout(() => {
      setAnimate(true);
    }, 300); // Delay animation to make it smoother
  }, []);

  const GetUserModelData = async () => {
    setLoader(true);

    const userID = JSON.parse(localStorage.getItem("userID"));
    const userKeyID = localStorage.getItem("userKeyID");
    try {
      const response = await GetProfileDetails(userKeyID);
      if (response?.statusCode === 200) {
        setLoader(false);

        const ModelData = response?.responseData?.data || []; // Assuming the data is an array and we need the first item

        const dob = new Date(ModelData?.dob);

        const year = dob.getFullYear();
        const month = dob.getMonth() + 1; // Months are zero-based (0 = January)
        const day = dob.getDate();

        const [hours, minutes] = ModelData?.tob.split(":");
        const apiParam = {
          day: day,
          month: month,
          year: year,
          hour: hours,
          min: minutes,
          lat: fetchedLocation?.lat,
          lon: fetchedLocation?.lon,
          tzone: timezoneOffset,
        };
        await GetBasicDetails(apiParam);
        await GetAstroDetails(apiParam);
      } else {
        setLoader(false);

        console.error(
          "Error fetching data: ",
          response?.data?.data?.statusCode
        );
      }
    } catch (error) {
      setLoader(false);

      console.error("Error", error);
    }
  };
  const GetBasicDetails = async (apiParam) => {
    setLoader(true);
    try {
      const response = await birth_details(apiParam);
      if (response !== null && response !== undefined) {
        setLoader(false);

        setBasicDetailsObj((prev) => ({
          ...prev,
          Year: response?.year,
          Month: response?.month,
          Day: response?.day,
          Hour: response?.hour,
          Minute: response?.minute,
          // Latitude: response?.latitude,
          // Longitude: response?.longitude,
          // Timezone: response?.timezone,
          Seconds: response?.seconds,
          Ayanamsha: response?.ayanamsha,
          Sunrise: convertTo12Hour(response?.sunrise),
          Sunset: convertTo12Hour(response?.sunset),
        }));
      } else {
        setLoader(false);

        console.error("Error fetching data: ", response);
      }
    } catch (error) {
      setCustomErrorMassage(error?.response?.data?.msg)
      setShowErrorModal(true)
      setLoader(false);

      console.error("Error", error);
    }
  };
  const GetAstroDetails = async (apiParam) => {
    try {
      const response = await astro_details(apiParam);
      if (response !== null && response !== undefined) {
        // setLoader(false);

        setAstroDetailsObj((prev) => ({
          ...prev,
          Ascendant: response?.ascendant,
          AscendantLord: response?.ascendant,
          Varna: response?.Varna,
          Vashya: response?.Vashya,
          Yoni: response?.Yoni,
          Gan: response?.Gan,
          Nadi: response?.Nadi,
          SignLord: response?.SignLord,
          Sign: response?.sign,
          Naksahtra: response?.Naksahtra,
          NaksahtraLord: response?.NaksahtraLord,
          Charan: response?.Charan,
          Yog: response?.Yog,
          Karan: response?.Karan,
          Tithi: response?.Tithi,
          Yunja: response?.yunja,
          Tatva: response?.tatva,
          Alphabet: response?.name_alphabet,
          Paya: response?.paya,
        }));
      } else {
        // setLoader(false);

        console.error("Error fetching data: ", response);
      }
    } catch (error) {
      setCustomErrorMassage(error?.response?.data?.msg)
      setShowErrorModal(true)

      console.error("Error", error);
    }
  };

  const HandleCloseModal=()=>{
    setShowErrorModal(false)
    navigate("/")
  }
  return (
    <>
      <section className="about-one">
        {/* Shape */}
        <div className="about-one__shape">
          <img src="assets/images/shapes/about-1-shape-4.png" alt="careox" />
        </div>

        <div className="container">
          <div className="row">
            {/* Left Image Section */}
            <div className="col-xl-7 order-md-1 order-2">
              <div
                className="about-one__image wow fadeInLeft"
                data-wow-delay="100ms"
              >
                <div className="about-one__image__one">
                  <img src={AstrologyIo} alt="careox" />
                </div>
                <div className="about-one__image__two">
                  {/* <img src={AstrologyIt} alt="careox" /> */}
                </div>
                <div className="about-one__image__shape-one">
                  <img src={AstrologyIt} alt="careox" />
                </div>

              </div>
            </div>

            {/* Right Content Section */}
            <div className="col-xl-5 order-md-2 order-1 wow fadeInRight" data-wow-delay="200ms">
              <div className="about-one__content">
                {/* Section Title */}

                {/* Two Boxes */}
                <div className="row gutter-y-30">
                  <div className="col-md-12">
                    <div
                      className="about-one__content__box"
                      style={{ "--accent-color": "#ffa415" }}
                    >
                      <div className="about-one__content__box__top">
                        <div className="about-one__content__box__icon">
                          <img src={AstrologyIf} alt="Zakat Icon" />
                        </div>
                        <h5 className="about-one__content__box__title">
                          {t("Astro Details")}
                        </h5>
                      </div>
                      <div className="about-one__content__border"></div>
                      <div className="row gutter-y-30">
                        <div className="col-md-6">
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Ascendant")} :</b> {astroDetails?.Ascendant || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Varna")} :</b> {astroDetails?.Varna || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Yoni")} :</b> {astroDetails?.Yoni || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Nadi")} :</b> {astroDetails?.Nadi || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Sign")} :</b> {astroDetails?.Sign || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("NaksahtraLord")} :</b> {astroDetails?.NaksahtraLord || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Yog")} :</b> {astroDetails?.Yog || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Tithi")} :</b> {astroDetails?.Tithi || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Tatva")} :</b> {astroDetails?.Tatva || '-'}
                          </p>
                        </div>
                        <div className="col-md-6 numarologypoints">
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("AscendantLord")} :</b> {astroDetails?.AscendantLord || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Vashya")} :</b> {astroDetails?.Vashya || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Gan")} :</b> {astroDetails?.Gan || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("SignLord")} :</b> {astroDetails?.SignLord || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Naksahtra")} :</b> {astroDetails?.Naksahtra || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Charan")} :</b> {astroDetails?.Charan || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Karan")} :</b> {astroDetails?.Karan || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Yunja")} :</b> {astroDetails?.Yunja || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>{t("Alphabet")} :</b> {astroDetails?.Alphabet || '-'}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-md-6">
                  <div
                    className="about-one__content__box"
                    style={{ "--accent-color": "#ff5528" }}
                  >
                    <div className="about-one__content__box__top">
                      <div className="about-one__content__box__icon">
                        <span className="icon-charity"></span>
                      </div>
                      <h5 className="about-one__content__box__title">Help Raising</h5>
                    </div>
                    <p className="about-one__content__box__text">
                      <span className="about-one__content__box__text__icon">
                        <i className="icofont-check-circled"></i>
                      </span>
                      No matter what you you have.
                    </p>
                  </div>
                </div> */}
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Text */}
        </div>
      </section>
      <ErrorMassagePupUp show={showErrorModal} onHide={()=>HandleCloseModal()} Massage={customErrorMassage} />
    </>
  );
};

export default BasicDetails;
